import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';

import ArtistIcon from '@/assets/all-icons/artist-icon';
import config from "@/config";
import useGetSearchParams from "@/hooks/useGetSearchParams";
import useQuery from "@/hooks/useQuery";
import HomeHeader from '@/shared-components/home/components/HomeHeader';
import Loader from '@/shared-components/loader/Loader';  // ✅ Updated Import
import Text from "@/shared-components/text/components/Text";
import AppNavigationPage from '@/shared-components/wrappers/components/AppNavigationPage';

import VirtualList from "./components/VirtualList";

import './index.css';

export default function HomeArtists({ fromSearch = false, valueFromSearch = "" }) {
  const [params, setParams] = useGetSearchParams();
  const [query, setQuery] = useState(params ? params : { q: "" });
  const { loading, queryData, loadMoreData } = useQuery("home_artists", `${config.apis.api.url}/search/artist`, query, {
    injectToken: true,
  });

  function onInput(value) {
    const newQuery = { q: value };
    setQuery(newQuery);
    setParams(newQuery, { replace: true });
  }

  useEffect(() => {
    onInput(valueFromSearch.q);
  }, [valueFromSearch.q]);

  return (
    <>
      { !fromSearch &&
        <div>
          <Helmet>
            <title>Artists | Suarte</title>
            <meta
              name="description"
              content="Who will be next? Discover and follow contemporary artists from all around the globe. Visit their profiles, artworks, and keep up with their artistic careers."
            />
          </Helmet>
          <AppNavigationPage>
            <div className="home-artists__page">
              <HomeHeader 
                onInput={onInput} 
                value={query.q} 
                icon={<ArtistIcon className="home-artists__header-icon"/>} 
                text="Artists" 
                placeholder="Search for artists..."
              />
              {/* ✅ Loader replacement */}
              {loading ? (
                <Loader />
              ) : queryData.data.data.length === 0 ? (
                <Text className="home-artists__empty-text" paragraph medium>
              Represented artists will be added soon!
                </Text>
              ) : (
                <VirtualList 
                  key={queryData.queryString} 
                  items={queryData.data} 
                  onLoadMore={loadMoreData}
                />
              )}
            </div>
          </AppNavigationPage>
        </div>
      }
      { fromSearch &&
        <>
          {
            loading ? 
              <Loader/>
              : queryData.data.data.length === 0 ?
                <Text className="home-artists__empty-text" paragraph medium>
                  Represented artists will be added soon!
                </Text>
                :
                <VirtualList 
                  key={queryData.queryString} 
                  items={queryData.data} 
                  onLoadMore={loadMoreData}
                  fromSearch={fromSearch}
                />
          }
        </>
      }

    </>
  );
}
